import { __decorate } from "tslib";
import _ from 'lodash';
import { provide } from '@/inversify.config';
export class PollingService {
    constructor({ generator, onLoopError, onEmptyHooks }) {
        this.hooks = [];
        this.loop = false;
        this.loopTimer = null;
        this.delay = 5000;
        this.onLoopError = _.noop;
        this.onEmptyHooks = _.noop;
        this.generator = generator;
        this.hooks = [];
        this.loop = false;
        this.loopTimer = null;
        this.delay = 5000;
        this.onLoopError = onLoopError || _.noop;
        this.onEmptyHooks = onEmptyHooks || _.noop;
    }
    addHook(hook, name) {
        this.hooks.push(hook);
        this.loopHandler();
        return () => {
            const index = this.hooks.indexOf(hook);
            index > -1 && this.hooks.splice(index, 1);
            console.info(`[Hook removed]: ${name}`);
            this.loopHandler();
        };
    }
    emptyHooks() {
        this.hooks = [];
        this.loopHandler();
        this.onEmptyHooks();
    }
    loopHandler() {
        if (this.hooks && this.hooks.length && !this.loop) {
            this.startLoop();
        }
        if (!(this.hooks && this.hooks.length) && this.loop) {
            this.endLoop();
        }
    }
    startLoop() {
        this.loop = true;
        this.loopAction(true);
    }
    endLoop() {
        this.loop = false;
        clearTimeout(this.loopTimer);
    }
    loopAction(isInit) {
        clearTimeout(this.loopTimer);
        if (!this.loop)
            return;
        this.loopTimer = setTimeout(() => {
            this.generator()
                .then((response) => {
                _.forEach(this.hooks, (hook) => {
                    hook(response, this);
                });
                this.loopAction(false);
            })
                .catch((error) => {
                this.onLoopError(error);
                this.emptyHooks();
            });
        }, isInit ? 0 : this.delay);
    }
}
export const PollingServiceFactorySymbol = Symbol.for('PollingServiceFactory');
let PollingServiceFactory = class PollingServiceFactory {
    getInstance({ generator, onLoopError, onEmptyHooks }) {
        return new PollingService({ generator, onLoopError, onEmptyHooks });
    }
};
PollingServiceFactory = __decorate([
    provide(PollingServiceFactorySymbol)
], PollingServiceFactory);
export { PollingServiceFactory };
